module.exports = __webpack_public_path__ + "static/media/profile_active.84dc5856.svg";